export const Urls = {
    BaseURL: 'cdn-base-url',

    // Page ids
    page_equipmentHouse: '2191',

    // Form ids
    form_equipmentHouse: '996',

    // Needs to be updated
    triage_tool: 'na', 

    equipmentHouseLincolnshire: '228',
    equipmentHouseYork: '231',
    assessment: '222',
    equipmentHouseLeeds: '252',
    dementiaQuestionnaireYork: '305',
    mentalHealthQuestionnaireYork: '351'
    
}